import React from 'react';

const NodeSideIcon: React.FC = () => (
  <svg
    width='81'
    height='82'
    viewBox='0 0 81 82'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_8979_39143)'>
      <path
        d='M40.2857 24H62L22 64V42.2857C22 35.8851 22 32.6848 23.2456 30.2401C24.3413 28.0897 26.0897 26.3413 28.2401 25.2456C30.6848 24 33.8851 24 40.2857 24Z'
        fill='url(#paint0_linear_8979_39143)'
      />
    </g>
    <path d='M62 64L22 64L62 24L62 64Z' fill='black' />
    <defs>
      <filter
        id='filter0_d_8979_39143'
        x='0.285713'
        y='0.857142'
        width='80.5714'
        height='80.5714'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='-1.42857' dy='-2.85714' />
        <feGaussianBlur stdDeviation='10.1429' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_8979_39143'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_8979_39143'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_8979_39143'
        x1='34.8181'
        y1='24'
        x2='56.2105'
        y2='64'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#D9D9D9' />
        <stop offset='0.438695' stop-color='#4C4C4C' />
        <stop offset='1' stop-color='#BEBEBE' />
      </linearGradient>
    </defs>
  </svg>
);

export default NodeSideIcon;
